import { create } from "zustand";

interface PaymentSquareState {
  isProcessing: boolean;
  checkoutId: string | null;
  setProcessing: (isProcessing: boolean) => void;
  setCheckoutId: (checkoutId: string) => void;
  orderId: string | null;
  setOrderId: (orderId: string) => void;
}

export const usePaymentSquareStore = create<PaymentSquareState>((set) => ({
  isProcessing: false,
  setProcessing: (isProcessing) => set({ isProcessing }),
  checkoutId: null,
  setCheckoutId: (checkoutId) => set({ checkoutId }),
  orderId: null,
  setOrderId: (orderId) => set({ orderId }),
}));